export const LOCAL = 'LOCAL';
export const DEVELOP = 'DEVELOP';
export const STAGE = 'STAGE';
export const PRODUCTION = 'PRODUCTION';
